import React, {useState} from 'react';
import {useHistory} from "react-router-dom";
import {Button, Modal} from "antd";

const UserProfile = () => {
    let history = useHistory()
    const [deleteModal, setDeleteModal] = useState(false);

    const logout = () => {

        setDeleteModal(true);
    }

    const handleCancelDelete = () => {
        setDeleteModal(false);
    };

    const handleOkDelete = () => {
        history.push("/login")
        localStorage.clear()
    }

    return (
        <div className="UserProfile">
            <div className="profile-header">
                <h3 className="font-family-medium">Профиль сотрудника</h3>
                <div className="d-flex profile-header-box">
                    <div className="left-img-box">
                        <div className="user-img-box">
                            <img src="/img/profileAv.png" alt=""/>
                            <label htmlFor="userimg">Изменить</label>
                        </div>
                    </div>
                    <div className="right-content-box">
                        <div className="inputs-box">
                            <label className="font-family-medium text-white">Имя и фамилия </label>
                            <input type="text"/>
                        </div>
                        <div className="inputs-box">
                            <label className="font-family-medium text-white">Логин / Номер телефона </label>
                            <input type="text"/>
                        </div>
                        <div className="con-btn">
                            <button className="font-family-medium"><span>Сохранить изменения</span></button>
                            <button className="font-family-medium ml-8  ">Отменить</button>
                        </div>
                    </div>
                </div>
                <button className="profi-exit-btn" onClick={logout}>
                    Выйти
                </button>
            </div>
            <Modal title="Внимание!"
                   open={deleteModal}
                   onCancel={handleCancelDelete}
                   footer={[
                       <Button key="submit" type="default" onClick={handleCancelDelete}>
                           Отменить
                       </Button>,
                       <Button key="submit" type="danger" className="my-red-canc bg-danger text-white-main" onClick={handleOkDelete}>
                           Да, выйти
                       </Button>
                   ]}
            >
                <p className="pt-2 pb-2">Вы хотите выйти из системы?</p>
            </Modal>
        </div>
    );
};

export default UserProfile;